export { default } from './RecipientDetails';
